export const import_theme_atom_to_client_service = {
  error_unknown: 'Quelque chose ne va pas',
  import_error: `Erreur lors de l\'importation`,
  import_success: 'Importation réussie',
  importing: 'Importation en cours',
} as const;
